import React, { FC } from "react";
import { Control, useController } from "react-hook-form";

import InputBase, { InputProps } from "@/components/ui/Form/Input/InputBase";

export interface InputControlledProps extends InputProps {
  control: Control;
}
const InputControlled: FC<InputControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <InputBase field={field} fieldState={fieldState} {...rest} />;
};
export default InputControlled;
